/** @jsxImportSource @emotion/react */

import { useTheme } from '@emotion/react';
import { useLayoutEffect } from 'react';
import { data } from '../Data/index';
import { isPrerender } from '../../utilities/is-prerender';
import { loadScript } from '../../utilities/load-script';

export const NewsletterPanel = () => {
  const theme = useTheme();

  useLayoutEffect(() => {
    if (!isPrerender()) {
      loadScript('https://js.createsend1.com/javascript/copypastesubscribeformlogic.js');
    }
  }, []);

  return (
    <section
      css={{
        background: theme.color.greyLight,
        padding: '1rem 1.5rem',

        [`@media (min-width: 860px)`]: {
          padding: '2.5rem 1.5rem'
        }
      }}
    >
      <div
        css={{
          margin: '0 auto 3rem auto',
          maxWidth: '1014px'
        }}
      >
        <div
          css={{
            textAlign: 'center',
            margin: '0 auto 3rem auto',
            maxWidth: '40rem'
          }}
        >
          <p
            css={{
              color: theme.color.slateDark,
              fontFamily: theme.fontFamily.heading,
              fontSize: theme.fontSizes[4],
              fontWeight: theme.fontWeights.semibold,
              marginBottom: '1.5rem',
              textAlign: 'center',

              [`@media (min-width: 640px)`]: {
                marginBottom: '2.5rem',
                fontSize: theme.fontSizes[8]
              }
            }}
          >
            {data.dictionary.newsletter_heading}
          </p>
          <p css={{ color: theme.color.slate, maxWidth: '524px', margin: '0 auto' }}>{data.dictionary.newsletter_description}</p>
        </div>
        <div
          css={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <form
            className="js-cm-form"
            id="subForm"
            action="https://www.createsend.com/t/subscribeerror?description="
            method="post"
            data-id="191722FC90141D02184CB1B62AB3DC26FF6881AED50F0BB177AC2370B8311F6D210E0934007B95E8845871EBA5EE857EF511949E8B81F71566402F5F16138FC3"
            css={{
              margin: '0 auto',
              width: '100%'
            }}
          >
            <div
              css={{
                [`@media (min-width: 860px)`]: {
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-end'
                }
              }}
            >
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  margin: '0.5rem 1rem 0 0',
                  width: '100%',

                  [`@media (min-width: 860px)`]: {
                    width: '20rem'
                  }
                }}
              >
                <label
                  css={{
                    color: theme.color.slate,
                    fontSize: theme.fontSizes[4],
                    fontWeight: theme.fontWeights.semibold
                  }}
                  htmlFor="fieldName"
                >
                  {data.dictionary.newsletter_label_name}
                </label>
                <input
                  css={{
                    background: theme.color.greyLight,
                    border: '1px solid',
                    borderColor: theme.color.slate,
                    boxSizing: 'border-box',
                    fontSize: theme.fontSizes[3],
                    marginTop: '0.25rem',
                    padding: '1rem 1.5rem',
                    width: '100%'
                  }}
                  aria-label="Name"
                  id="fieldName"
                  maxLength={200}
                  name="cm-name"
                  required={true}
                />
              </div>
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  margin: '0.5rem 1rem 0 0',
                  width: '100%',

                  [`@media (min-width: 860px)`]: {
                    width: '20rem'
                  }
                }}
              >
                <label
                  css={{
                    color: theme.color.slate,
                    fontSize: theme.fontSizes[4],
                    fontWeight: theme.fontWeights.semibold
                  }}
                  htmlFor="fieldEmail"
                >
                  {data.dictionary.newsletter_label_email}
                </label>
                <input
                  css={{
                    background: theme.color.greyLight,
                    border: '1px solid',
                    borderColor: theme.color.slate,
                    boxSizing: 'border-box',
                    fontSize: theme.fontSizes[3],
                    marginTop: '0.25rem',
                    padding: '1rem 1.5rem',
                    width: '100%'
                  }}
                  autoComplete="Email"
                  aria-label="Email"
                  className="js-cm-email-input qa-input-email"
                  id="fieldEmail"
                  maxLength={200}
                  name="cm-xjtnl-xjtnl"
                  required={true}
                  type="email"
                />
              </div>
              <button
                type="submit"
                css={{
                  boxSizing: 'border-box',
                  background: theme.color.primary,
                  border: '1px solid transparent',
                  borderRadius: '2.5rem',
                  color: theme.color.white,
                  cursor: 'pointer',
                  fontFamily: theme.fontFamily.body,
                  fontSize: theme.fontSizes[4],
                  fontWeight: theme.fontWeights.semibold,
                  marginTop: '1rem',
                  padding: '0.5rem 1rem',
                  textTransform: 'uppercase',
                  transition: 'background-color .1s ease-in,border-color .1s ease-in,color .1s ease-in',
                  width: '100%',

                  [`@media (min-width: 860px)`]: {
                    margin: 0,
                    padding: '1rem 1.5rem',
                    width: '9.5rem'
                  },

                  '&:focus, &:hover': {
                    background: theme.color.white,
                    border: `1px solid ${theme.color.black}`,
                    color: theme.color.primary
                  },

                  '&:focus:not(:focus-visible)': {
                    outline: 'none'
                  }
                }}
              >
                {data.dictionary.newsletter_signup}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

NewsletterPanel.displayName = 'NewsletterPanel';
